import { IValidator, IValidations, IParentProfile, IStudentListItem, IStudentListAccountItem } from '@/interfaces';
import { isMinecraftUsername } from '@/utils';

export class ParentProfileValidator implements IValidator<IParentProfile<IStudentListAccountItem>> {
  public isValid(item: IParentProfile<IStudentListAccountItem>) {
    const errors: IValidations<IParentProfile<IStudentListAccountItem>> = {};
    if (item.firstName.length === 0) errors.firstName = ['First Name is required'];
    if (item.lastName.length === 0) errors.lastName = ['Last Name is required'];
    if (item.email.length === 0) errors.email = ['Email is required'];
    if (item.phone.length === 0) errors.phone = ['Phone is required'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}

export class StudentListItemValidator implements IValidator<IStudentListItem> {
  public isValid(item: IStudentListItem) {
    const errors: IValidations<IStudentListItem> = {};
    if (item.firstName.length === 0) errors.firstName = ['First Name is required'];
    if (item.lastName.length === 0) errors.lastName = ['Last Name is required'];
    if (!isMinecraftUsername(item.minecraftAccountUserName)) errors.minecraftAccountUserName = ['Not a valid minecraft account name'];
    if (item.moodleUserName.length === 0) errors.moodleUserName = ['Moodle Username is required.'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}